// Single source of truth for FAQs shown on the Packages page and in the footer
// FAQ popup. Keep answers consistent with FooterPopUps/CancellationPolicy.jsx and
// the Permits guide page.

const faqs = [
  {
    question: "What kind of treks do you offer?",
    answer:
      "We offer guided treks in the Nepal Himalaya, from short hikes near Kathmandu to multi-day high-altitude routes such as Everest Base Camp. Each trek page lists its route, duration, day-by-day itinerary and price, and some treks let you choose between more than one route.",
  },
  {
    question: "Do I need prior trekking experience?",
    answer:
      "Most of our treks don't require previous trekking experience, but they do require good fitness. Expect to walk around 4–7 hours a day, often at altitude, so build up regular cardio and hill walking in the months before your trip.",
  },
  {
    question: "When is the best season to trek in Nepal?",
    answer:
      "Spring (March–May) and autumn (September–November) have the most stable weather and the clearest mountain views. Winter (December–February) is possible on lower routes but very cold at altitude, and the monsoon (June–August) brings rain, cloud and slippery trails.",
  },
  {
    question: "How do I book a trek?",
    answer:
      "Open a trek from the Packages page, choose your route, start date and number of guests, then continue to checkout. You can book as a guest, or sign in to manage your bookings from your dashboard.",
  },
  {
    question: "How do I pay?",
    answer:
      "You pay securely online by card at checkout, processed by Stripe. Before you pay, the booking summary shows the price per person along with any taxes, fees and group discounts that apply.",
  },
  {
    question: "What is your cancellation policy?",
    answer:
      "Cancellations must be made in writing. Cancel 30 or more days before departure for a refund minus service fees, 15–29 days before for a 50% refund, and within 15 days there is no refund. Permit and flight costs can't be refunded once issued.",
  },
  {
    question: "Is travel insurance mandatory?",
    answer:
      "Yes. Your travel insurance must cover trekking at the altitudes on your route, emergency helicopter evacuation and medical expenses. Check that the policy's altitude limit is higher than the highest point of your trek.",
  },
  {
    question: "What permits do I need?",
    answer:
      "It depends on the region. Most treks need a national park or conservation area permit plus a TIMS card — or, in the Everest region, a local Khumbu entry permit instead of TIMS. Restricted areas such as Manaslu also need a Restricted Area Permit and must be trekked with a licensed guide. Our local team helps you arrange the permits for your trek, and our Guide page lists current fees.",
  },
  {
    question: "Who will be our guides?",
    answer:
      "Treks are led by licensed, experienced Nepali guides trained in first aid and high-altitude safety.",
  },
];

export default faqs;
